import * as React from "react";
import { forwardRef } from "react";
const SvgUnSelectedRadioButton = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 10, cy: 10, r: 7.5, fill: "white", stroke: "#C2CCD6" }));
const ForwardRef = forwardRef(SvgUnSelectedRadioButton);
export default ForwardRef;
